<template>
    <div class="flex flex-col lg:flex-row">
        <div class="w-full lg:w-3/5">
            <map-drain
                class="home-map"
                :adopted-drain-ids="adoptedDrainIds"
                :initial-center="center"
                :my-drain-ids="myDrainIds"
                :selected-drain="selectedDrain"
                :user="user"
                v-on:update:center="updateMapCenterListener"
                v-on:update:zoom="updateMapZoomListener"
            />
        </div>

        <div class="flex items-center justify-center px-12 py-20 text-center lg:w-2/5">
            <div class="w-full">
                <div>
                    <div v-if="regionName">
                        <p class="mb-2 text-3xl font-semibold lg:text-4xl text-grey-darkest">
                            {{ regionName }}
                        </p>

                        <p class="mb-8 text-lg font-semibold lg:text-xl">
                            <a
                                :href="changeRegionUrl"
                                alt="Change Locations"
                                class="no-underline text-teal-dark hover:text-teal-darker"
                            >
                                Change region
                            </a>
                        </p>

                        <div class="block w-16 h-1 mx-auto my-8 bg-teal-darker"></div>
                    </div>

                    <label
                        for="gmap-autocomplete"
                        class="block mb-8 text-3xl font-semibold lg:text-4xl lg:font-normal"
                    >
                        Enter your address to select a drain.
                    </label>
                </div>

                <autocomplete @placeChanged="({center}) => this.center = center"></autocomplete>

                <div class="mt-20" v-if="suggestedDrainsEnabled">
                    <p class="text-lg leading-relaxed">
                        Don't see your drain? <br />
                    </p>
                    <p class="mt-1 text-lg leading-relaxed">
                        <a
                            :href="suggestDrainUrl"
                            class="mt-4 font-bold no-underline text-teal-darker"
                        >
                            Add one here.
                        </a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MapDrain from './MapDrain';
import Autocomplete from './Autocomplete';


export default {
    components: { MapDrain, Autocomplete },

    props: {
        adoptedDrainIds: { default: null },
        initialCenter: {},
        myDrainIds: { default: null },
        selectedDrain: { default: null },
        user: { default: null },
        suggestedDrainsEnabled: { default: false },
    },

    data() {
        return {
            center: this.initialCenter,
            regionName: window.App.region,
            changeRegionUrl: window.App.changeRegionUrl,
            mapCenter: {},
            mapZoom: 17,
        };
    },

    computed: {
        suggestDrainUrl: function() {
            return (
                'suggested-drains/create?' +
                new URLSearchParams({
                    zoom: this.mapZoom,
                    lat: this.mapCenter.lat,
                    lng: this.mapCenter.lng,
                }).toString()
            );
        },
    },

    methods: {
        setPlace(place) {
            this.center = place.geometry.location;
        },
        updateMapCenterListener: function(data) {
            this.mapCenter = data;
        },
        updateMapZoomListener: function(data) {
            this.mapZoom = data;
        },
    },
};
</script>
